import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  verifyEmail,
  reVerifyEmail,
  clearVerifyEmailState,
} from "../../redux/Actions/SingleUserActions";
import { sendNewPassword } from "../../redux/Actions/PasswordActions";
import Loader from "../../components/Loader/Loader";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import Mail from "../../assets/assets/mail.svg";
import Button from "../../components/Button/Button";
import Alert from "../../utils/Alert";
import { PropTypes } from "prop-types";
import { useHistory } from "react-router-dom"

const VerifyEmail = ({
  location,
  match,
  isVerifying,
  verifyEmail,
  verifiedEmail,
  reVerifying,
  reVerifyEmail,
  reVerifiedEmail,
  status,
}) => {
  const [inputValue, setInputValue] = useState("");
  const history = useHistory();

  const [state, setState] = useState({
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
  });
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  const emailAddress = query.get("email")
    ? query.get("email")
    : location.state.email
    ? location.state.email
    : "";

  useEffect(
    () => {
      setInputValue(Object.values(state).join(""));
      if (verifiedEmail) {
        setState({
          ...state,
          inputValue: "",
          openModal: true,
        });
      }
    },
    // eslint-disable-next-line
    [verifiedEmail]
  );

  const updateInputValue = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    setInputValue(Object.values(state).join(""));
  }, [state, inputValue]);

  const verify = () => {
    const codeNo = {
      code: inputValue,
      email: emailAddress
    };
    verifyEmail(codeNo);
  };

  const reVerify = () => {
    const email = {
      email: emailAddress,
      type: "default"
    };
    reVerifyEmail(email);
  };

  const TakeToLogin = () => {
    history.push("/login")
    clearVerifyEmailState()
  }

  useEffect(() => {
    if (reVerifiedEmail) {
      Alert(
        true,
        "success",
        "success message",
        "A new verification email has been successfully sent to your email."
      );
    }
  },
  // eslint-disable-next-line
  [reVerifiedEmail]);

  const moveOnMax = (field, nextId) => {
    if (field.length >= 1) {
      document.getElementById(nextId).focus();
    }
  };

  return (
    <div className="wrapper">
      <div className="verification-logo">
        <img src={Nibss} alt="logo" />
      </div>
      <div className="body-wrap">
        <div className="mail">
          <img src={Mail} alt="mail" />
        </div>
        {!verifiedEmail ? (
          <>
            <div className="verification-text">
              <p className="verification-text-header">
                Just one more step, Let's verify your email address
              </p>
              <p className="verification-text-paragraph">
                We already sent a code to {emailAddress}, please check the inbox
                and insert the 6 digit code in the form below to verify your
                email
              </p>
            </div>
            <div className="verification-input-wrap">
              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value1"
                value={state.value1}
                id="one"
                onChange={updateInputValue}
                onKeyUp={() => moveOnMax(state.value1, "two")}
              />

              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value2"
                value={state.value2}
                onChange={updateInputValue}
                id="two"
                onKeyUp={() => moveOnMax(state.value2, "three")}
              />

              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value3"
                value={state.value3}
                id="three"
                onChange={updateInputValue}
                onKeyUp={() => moveOnMax(state.value3, "four")}
              />

              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value4"
                value={state.value4}
                id="four"
                onChange={updateInputValue}
                onKeyUp={() => moveOnMax(state.value4, "five")}
              />

              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value5"
                value={state.value5}
                id="five"
                onChange={updateInputValue}
                onKeyUp={() => moveOnMax(state.value5, "six")}
              />

              <input
                className="verification-input"
                type="text"
                pattern="/^-?\d*$/"
                maxLength="1"
                name="value6"
                value={state.value6}
                id="six"
                onChange={updateInputValue}
              />
            </div>
            <div className="verification-confirmation">
              <span className="verification-confirmation-text">
                Didn’t get the code?{" "}
                <span id="resend" onClick={reVerify}>
                  resend
                </span>
              </span>

              <Button
                width="200px"
                word={isVerifying ? <Loader /> : "CONTINUE"}
                disabled={
                  isVerifying || inputValue === "" || inputValue.length !== 6
                }
                onClick={verify}
              />
            </div>
            <div className="verification-bottom">
              <p className="verification-bottom-text">
                Don’t worry its only a one time passcode, once your email is
                verified you won’t need it anymore
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="verification-success-wrap">
              <p className="verification-success-pragraph">
                Your Email has been successfully verified
              </p>
              <div className="verification-button">
                  <Button
                    className="verification-confirmation-button"
                    width="400px"
                    onClick={TakeToLogin()}
                    word={isVerifying ? <Loader /> : "PROCEED"}
                  />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isVerifying: state.singleUser.isVerifying,
    verifiedEmail: state.singleUser.verifiedEmail,
    reVerifying: state.singleUser.reVerifying,
    reVerifiedEmail: state.singleUser.reVerifiedEmail,
    status: state.singleUser.reVerificationStatus,
  };
};

const mapDispatchToProps = (dispatch) => ({
  verifyEmail: (payload) => dispatch(verifyEmail(payload)),
  reVerifyEmail: (payload) => dispatch(reVerifyEmail(payload)),
  resendPassword: (payload) => dispatch(sendNewPassword(payload)),
  clearVerifyEmailState: () => dispatch(clearVerifyEmailState())
});

VerifyEmail.propTypes = {
  clearVerifyEmailState: PropTypes.func,
  isVerifying: PropTypes.bool,
  location: PropTypes.node,
  match: PropTypes.node,
  reVerifiedEmail: PropTypes.bool,
  reVerifyEmail: PropTypes.func,
  reVerifying: PropTypes.bool,
  status: PropTypes.object,
  verifiedEmail: PropTypes.node,
  verifyEmail: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);
